// extracted by mini-css-extract-plugin
module.exports = {"SectionStyle":"Section_SectionStyle__2eC19","next-btn":"Section_next-btn__3bcZi","text-icons":"Section_text-icons__2Ido2"};